import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toaster } from "../../actions/showToast";

export default function AddVideo(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onClickAddVideo = () => {
    console.log("--Add Video..");
    dispatch(toaster(t("Click a point to add a button Video"), "warning"));
    props.changeMyTool("addvideo");
  };
  return (
    <li onClick={onClickAddVideo}>
      <span
        className={`button normal-btn next-page ${
          props.shouldShowButtonLabels ? "show-label-span" : ""
        } ${
          props.activeButton === "addvideo" ? "active" : ""
        }`}
        title={t("Add Video")}
        data-tip={t("Add Video")}
      >
        <img
          src={require("../../assets/img/svg/tools-video.svg")}
          alt={t("Add Video")}
        />
        {props.shouldShowButtonLabels && <span className="show-label-text">{t("Video")}</span>}
      </span>
    </li>
  );
}
